/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

const DesktopCardInfo = ({
    className, title, body, cartStyle,
}) => (
    <Card className={`margin-top bottom-modify-card  card-info ${className} ${cartStyle}`}>
        <CardContent className="padding-zero">
            <div className="desktop-card-title padding-10">{title}</div>
            {body}
        </CardContent>
    </Card>
);

DesktopCardInfo.defaultProps = {
    title: '',
    body: '',
    className: '',
    cartStyle: '',
};

DesktopCardInfo.propTypes = {
    title: PropTypes.object,
    body: PropTypes.object,
    className: PropTypes.string,
    cartStyle: PropTypes.string,
};

export default DesktopCardInfo;
